import { ENDPOINTS } from '../endpoints';
import { api } from '../client/axiosClient';
import {
  AddOrganizationsToGroupRequest,
  AddOrganizationsToGroupResponse,
} from '../types/dtos/organization/groups-organization';

/**
 * GroupsOrganizationService handles operations for managing organizations within groups.
 *
 * URL Pattern: /api/v1/groups/{groupId}/organizations
 * Organization context is provided via X-Organization-Id header (injected by axiosClient).
 *
 * Migration: The organizationId parameter has been removed from URL paths. The backend
 * extracts organization context from the X-Organization-Id header for tenant scoping.
 *
 * VAL-GRG-003: Group List with X-Organization-Id Header
 */
export class GroupsOrganizationService {
  /**
   * Get all organizations linked to a specific group
   * @param _organizationId - Deprecated: Organization ID (no longer used, kept for backward compatibility)
   * @param groupId - Group UUID
   */
  async getGroupOrganizations(
    _organizationId: string,
    groupId: string,
    params?: { isActive?: boolean }
  ): Promise<any> {
    const queryParams = new URLSearchParams();
    if (params?.isActive !== undefined) {
      queryParams.append('isActive', String(params.isActive));
    }
    
    const url = ENDPOINTS.groupsOrganizations.list(_organizationId, groupId);
    const fullUrl = queryParams.toString() ? `${url}?${queryParams.toString()}` : url;
    
    return api.get(fullUrl);
  }

  /**
   * Add organizations to a group
   * @param _organizationId - Deprecated: Organization ID (no longer used, kept for backward compatibility)
   * @param groupId - Group UUID
   */
  async addOrganizationsToGroup(
    _selectedOrganizationId: string,
    groupId: string,
    organizationIds: AddOrganizationsToGroupRequest
  ): Promise<AddOrganizationsToGroupResponse> {
    return api.post(
      ENDPOINTS.groupsOrganizations.createBatchRelations(_selectedOrganizationId, groupId),
      organizationIds
    );
  }

  /**
   * Get groups by organization ID
   * @param _orgId - Deprecated: Organization ID (no longer used, kept for backward compatibility)
   */
  async getGroupsByOrganizationId(_orgId: string): Promise<any> {
    return api.get(ENDPOINTS.organizations.groups(_orgId));
  }

  /**
   * Delete a group relation
   * @param _organizationId - Deprecated: Organization ID (no longer used, kept for backward compatibility)
   * @param groupId - Group UUID
   * @param groupOrganizationId - Group organization relation UUID
   */
  async deleteGroupRelation(
    _organizationId: string,
    groupId: string,
    groupOrganizationId: string
  ): Promise<any> {
    return api.delete(
      ENDPOINTS.groupsOrganizations.deleteRelation(_organizationId, groupId, groupOrganizationId)
    );
  }
}

export const groupsOrganizationService = new GroupsOrganizationService(); 